import React from 'react';
import Layout from '../../components/Layout';
import messages from '../../locale/messages';
import Faqs from './Faqs';

const title = 'Frequently Asked Questions';

export default function action({ intl }) {

  const title = intl?.formatMessage(messages.staticFaqs);

  return {
    title,
    component: <Layout><Faqs title={title} /></Layout>,
  };
}
